import { render } from "./PinkFlower.svg?vue&type=template&id=dd8a6ace"
const script = {}
script.render = render

export default script